import { InitAssignmentSessionResponse, InitExerciseSessionResponse } from '../../api/exercises-api';
import LaunchModalCompletedSession from './launch-modal-completed-session';
import LaunchModalPausedSession from './launch-modal-paused-session';

interface ExerciseLaunchModalsProps {
  exerciseSession?: InitExerciseSessionResponse;
  onResume?: () => void;
  onRestart?: () => void;
  onReview: (sessionId: string) => void;
}

function isAssignmentSession(response: InitExerciseSessionResponse): response is InitAssignmentSessionResponse {
  return 'isExpired' in response;
}

function ExerciseLaunchModals({
  exerciseSession,
  onRestart,
  onResume,
  onReview,
}: ExerciseLaunchModalsProps): JSX.Element | null {
  if (!exerciseSession || !exerciseSession.result) return null;

  const canRestart =
    !isAssignmentSession(exerciseSession) || (!exerciseSession.isExpired && exerciseSession.restartable);

  const canResume = !isAssignmentSession(exerciseSession) || !exerciseSession.isExpired;

  return exerciseSession.resumable ? (
    <LaunchModalPausedSession
      result={exerciseSession.result}
      onRestart={canRestart ? onRestart : undefined}
      onResume={canResume ? onResume : undefined}
    />
  ) : (
    <LaunchModalCompletedSession
      result={exerciseSession.result}
      onRestart={canRestart ? onRestart : undefined}
      onReview={onReview}
    />
  );
}

export default ExerciseLaunchModals;
